import { render, staticRenderFns } from "./currency-input.vue?vue&type=template&id=0b670e69"
import script from "./currency-input.vue?vue&type=script&lang=js"
export * from "./currency-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports